module.exports = __webpack_public_path__ + "static/step-1.2ce7aea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/filtering/step-1.png
// module id = 2563
// module chunks = 100095027350696